<template>
  <div class="collect">
    <div class="search-warehouse">
      <div class="add">
        <el-button class="btn-blue" @click="add">新增采集标准</el-button>
      </div>
    </div>
    <div class="table">
      <el-table ref="table" :data="collectionTemplateList" style="width: 100%"
      :row-class-name="tableRowClassName">
        <el-table-column 
          v-for="(item, index) in tableTitleList"
          :key="index"
          :label="item.label"
          :prop="item.prop"
        >
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button :disabled="scope.row.status !== 1?true:false" class="btn-text" type="text" @click="mod(scope.row)">编辑</el-button>
            <el-button class="btn-text" type="text" @click="updateStatus(scope.row)">
              {{ scope.row.status?'关闭':'开启'}}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer">
      <pagination-tpl
        :total="setCollectionTemplatePage.total"
        :currentPage="setCollectionTemplatePage.currentPage"
        :pageSize="setCollectionTemplatePage.pageSize"
        @queryChange="queryChange"
      ></pagination-tpl>
    </div>

    <!-- 添加采集模板/编辑 -->
    <el-dialog
      :title="collectionForm.id ? '编辑' : '新增'"
      top="16vh"
      :visible.sync="collectionDialog"
      width="720px"
      class="collection-dialog"
    >
      <div class="border"></div>
      <el-form
        ref="collectionForm"
        :model="collectionForm"
        :rules="collectionFormRules"
      >
        <el-form-item label="采集模板" prop="name">
          <el-input v-model="collectionForm.name" class="white" placeholder="请输入采集模板"></el-input>
        </el-form-item>
        <el-form-item label="采集模板类型" prop="templateType">
          <el-radio-group v-model="collectionForm.templateType">
            <el-radio :label="1">普通</el-radio>
            <el-radio :label="2">SOP</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="search-warehouse" v-if="collectionForm.templateType === 2">
          <div class="add">
            <el-button class="btn-blue" @click="addDepartment">+添加部位</el-button>
          </div>
        </div>
        <div class="table" v-if="collectionForm.templateType === 2">
          <el-table ref="departmentTable" :data="departmentList" style="width: 100%">
            <el-table-column 
              v-for="(item, index) in departmentTableTitleList"
              :key="index"
              :label="item.label"
              :prop="item.prop"
            >
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button class="btn-text" type="text" @click="modDepartment(scope.row)">编辑</el-button>
                <el-button class="btn-text" type="text" @click="deleteDepartment(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeCollectDialog">取消</el-button>
        <el-button class="btn-blue" @click="saveCollect('collectionForm')">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="departmentForm.id ? '编辑' : '新增'"
      top="26vh"
      :visible.sync="departmentDialog"
      width="420px"
    >
      <div class="border"></div>
      <el-form
        ref="departmentForm"
        :model="departmentForm"
        :rules="departmentFormRules"
      >
        <el-form-item label="序号" prop="sortNo">
          <el-input v-model="departmentForm.sortNo" class="white" placeholder="请输入序号"></el-input>
        </el-form-item>
        <el-form-item label="留痕项目" prop="traceItem">
          <el-input v-model="departmentForm.traceItem" class="white" placeholder="请输入留痕项目"></el-input>
        </el-form-item>
        <el-form-item label="涉及部位" prop="partName">
          <el-input v-model="departmentForm.partName" class="white" placeholder="请输入涉及部位"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeDepartmentDialog">取消</el-button>
        <el-button class="btn-blue" @click="saveDepartment('departmentForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { modifyNetTitle } from "common/js/util";
import PaginationTpl from "components/base/PaginationTpl";
import CollectionTemplateMixins from "common/mixins/smart-vehicle-inspection/collection-template";
import SmartVehicleInspection from "models/smart-vehicle-inspection/smart-vehicle-inspection";
export default {
  mixins: [CollectionTemplateMixins],
  data() {
    return {
      tableTitleList: [
        {label: '序号', prop: 'sort'}, 
        {label: '采集模板', prop: 'name'}
      ],
      collectionDialog: false,
      collectionForm: {
        id: '',
        templateType: 1,
        name: ''
      },
      collectionFormRules: {
        name: [
          { required: true, message: "请输入采集模板", trigger: "blur" },
        ],
        templateType: [
          { required: true, message: "请选择采集模板类型", trigger: "blur" },
        ]
      },

      departmentList: [],
      departmentTableTitleList: [
        {label: '序号', prop: 'sortNo'}, 
        {label: '留痕项目', prop: 'traceItem'},
        {label: '涉及部位', prop: 'partName'}
      ],

      departmentDialog: false,
      departmentForm: {
        id: '',
        sortNo: '',
        traceItem: '',
        partName: ''
      },
      departmentFormRules: {
        sortNo: [
          { required: true, message: "请输入序号", trigger: "blur" },
        ],
        traceItem: [
          { required: true, message: "请输入留痕项目", trigger: "blur" },
        ],
        partName: [
          { required: true, message: "请输入涉及部位", trigger: "blur" },
        ]
      }
    };
  },
  components: {
    PaginationTpl
  },
  created() {
    modifyNetTitle('采集模板');
    this.initCollectionTemplateList();
  },
  methods: { 
    initCollectionTemplateDetails(id) {
      SmartVehicleInspection.getCollectionTemplateDetails(id).then(res => {
        if (res.success) {
          const { name, templateType, parts } = res.result
          this.departmentList = parts
          this.collectionForm.id = id
          this.collectionForm.name = name
          this.collectionForm.templateType = templateType
          this.add()
        }
      })
    },

    tableRowClassName({ row }) {
      if (row.status !== 1) {
        return "close-row";
      }
    },
    //翻页
    queryChange(data) {
      this.setCollectionTemplatePage.currentPage = data.currentPage;
      this.initCollectionTemplateList();
    },
    //新增
    add() {
      this.collectionDialog = true;
    },
    closeCollectDialog() {
      this.collectionForm.id = ''
      this.collectionForm.name = ''
      this.collectionDialog = false;
    },
    saveCollect(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.collectionForm.id) {
            let data = {};
            data.id = this.collectionForm.id;
            data.name = this.collectionForm.name;
            data.templateType = this.collectionForm.templateType;
            data.parts = this.departmentList
            SmartVehicleInspection.postModCollectionTemplate(data).then(res => {
              if (res.success) {
                this.initCollectionTemplateList();
                this.closeCollectDialog();
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            let data = {};
            data.name = this.collectionForm.name;
            data.templateType = this.collectionForm.templateType;
            data.parts = this.departmentList
            SmartVehicleInspection.postAddCollectionTemplate(data).then(res => {
              if (res.success) {
                this.initCollectionTemplateList();
                this.closeCollectDialog();
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    mod(row) {
      this.initCollectionTemplateDetails(row.id)
    },
    updateStatus(row) {
      const title = row.status?'是否关闭该采集模板？':'是否开启该采集模板？' 
      this.$confirm(title, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-blue',
        cancelButtonClass: 'btn-white'
      })
        .then(() => {
          this.commonFun(row)
        })
        .catch(() => {});
    },

    commonFun(row) {
      const data = {
        id: row.id,
        status: row.status?0:1,
      } 
      SmartVehicleInspection.postUpdateCollectionTemplateStatus(data).then(res => {
        if (res.success) {
          this.initCollectionTemplateList();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    addDepartment() {
      this.departmentDialog = true;
    },

    modDepartment(row) {
      this.departmentForm.id = row.id;
      this.departmentForm.sortNo = row.sortNo;
      this.departmentForm.traceItem = row.traceItem;
      this.departmentForm.partName = row.partName;
      this.departmentDialog = true;
    },

    deleteDepartment(row) {
      const index = this.departmentList.indexOf(row);
      if (index > -1) {
        this.departmentList.splice(index, 1);
      }
    },

    closeDepartmentDialog() {
      this.departmentForm.id = ''
      this.departmentForm.sortNo = ''
      this.departmentForm.traceItem = ''
      this.departmentForm.partName = ''
      this.departmentDialog = false;
    },

    saveDepartment() {
      this.$refs['departmentForm'].validate(valid => {
        if (valid) {
          if (this.departmentForm.id) {
            let data = {};
            data.sortNo = this.departmentForm.sortNo;
            data.traceItem = this.departmentForm.traceItem;
            data.partName = this.departmentForm.partName;
            this.departmentList.forEach((item, index) => {
              if (item.id === this.departmentForm.id) {
                this.$set(this.departmentList, index, data)
              }
            });
          } else {
            let data = {};
            data.id = new Date().getTime();
            data.sortNo = this.departmentForm.sortNo;
            data.traceItem = this.departmentForm.traceItem;
            data.partName = this.departmentForm.partName;
            this.departmentList.push(data)
          }
          this.closeDepartmentDialog();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss">
.collect {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  padding: 16px;
  box-sizing: border-box;
  .search-warehouse {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 16px;
  }
  
  .table .el-table .el-table__body-wrapper .el-table__body .close-row td .cell {
    color: #b7b7b7;
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 16px;
  }
  
  .el-dialog {
    .el-dialog__header {
      padding-left: 20px;
    }
    .el-dialog__body {
      padding: 0px;
      .el-form {
        padding: 20px;
        .el-form-item {
          .el-form-item__label {
            width: 100%;
            text-align: left;
          }
          .el-form-item__content {
            width: 100%;
          }
          
          .el-radio-group {
            .el-radio__input.is-disabled .el-radio__inner {
              background-color: white;
              border-color: #DDE1E7;
            }
            .el-radio__input.is-disabled.is-checked:hover {
              border-color: #DDE1E7;
            }

            .el-radio__input.is-disabled.is-checked .el-radio__inner,
            .el-radio__inner:hover,
            .el-radio__input.is-checked .el-radio__inner {
              background-color: white;
              border-color: #2E68EA;
            }

            .el-radio__input.is-disabled.is-checked .el-radio__inner::after,
            .el-radio__inner::after {
              background-color: #2E68EA;
            }

            .el-radio__input.is-checked+.el-radio__label {
              color: #2E68EA;
            }
          }
        }
      }
      .border {
        border-color: #EEEEEE;
        margin-bottom: 0px
      }
    }
    .dialog-footer {
      padding-bottom: 20px;
      border-top: 1px solid #f7f7f7;
      padding-top: 20px;
      display: flex;
      justify-content: center;
    }
  }
  .collection-dialog {
    .el-dialog {
      max-height: 500px;
      overflow-y: auto;
    }
  }
}
</style>
